export default __webpack_public_path__ + "static/986-13e77b783d30748287bd27320a02dbc1.gif";